import React from "react";
import OrderField from "./order_field";
import SpinLoading from "../../../../shared/spin_loading";

const OrderFieldSpinner = () => {
  return (
    <OrderField title={""}>
      <SpinLoading show={true} />
    </OrderField>
  );
};

export default OrderFieldSpinner;
